module.exports = __webpack_public_path__ + "static/img/logo-ring.c0ef0ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo-ring.png
// module id = bfdx
// module chunks = 0